// client/src/pages/PTO/ptoConstants.ts
// Constants for the PTO Dashboard — colors tuned for the dark theme.

import type { EntryType, Office } from './ptoTypes';

// ─── Entry type badge styles ─────────────────────────────────────────────────

export interface EntryTypeStyle {
  value: EntryType;
  label: string;
  bgColor: string;
  textColor: string;
}

export const ENTRY_TYPES: EntryTypeStyle[] = [
  { value: 'PTO',           label: 'PTO',           bgColor: 'rgba(122,162,255,.2)',  textColor: '#7aa2ff' },
  { value: 'Tentative PTO', label: 'Tentative PTO', bgColor: 'rgba(255,209,102,.15)', textColor: '#ffd166' },
  { value: 'Holiday',       label: 'Holiday',       bgColor: 'rgba(87,211,140,.15)',  textColor: '#57d38c' },
  { value: 'Appointment',   label: 'Appointment',   bgColor: 'rgba(255,209,102,.2)',  textColor: '#ffd166' },
  { value: 'Friday Work',   label: 'Friday Work',   bgColor: 'rgba(100,210,255,.15)', textColor: '#64d2ff' },
  { value: 'Sabbatical',    label: 'Sabbatical',    bgColor: 'rgba(187,154,247,.2)',  textColor: '#bb9af7' },
  { value: 'Work',          label: 'Work',           bgColor: 'rgba(100,210,255,.2)',  textColor: '#64d2ff' },
  { value: 'Flexing Off',   label: 'Flexing Off',   bgColor: 'rgba(255,158,100,.2)',  textColor: '#ff9e64' },
  { value: 'Deadline',      label: 'Deadline',      bgColor: 'rgba(255,107,107,.15)', textColor: '#ff6b6b' },
  { value: 'Half Day',      label: 'Half Day',      bgColor: 'rgba(122,162,255,.15)', textColor: '#7aa2ff' },
  { value: 'Other',         label: 'Other',         bgColor: 'rgba(167,179,196,.15)', textColor: '#a7b3c4' },
];

// ─── Office colors ───────────────────────────────────────────────────────────

export interface OfficeStyle {
  value: Office;
  label: string;
  color: string;
}

export const OFFICES: OfficeStyle[] = [
  { value: 'Birmingham', label: 'Birmingham', color: '#4a9ead' },
  { value: 'Mobile',     label: 'Mobile',     color: '#c05a7a' },
  { value: 'Huntsville', label: 'Huntsville', color: '#4aad6a' },
  { value: 'Gadsden',    label: 'Gadsden',    color: '#c0a040' },
  { value: 'Ridgeland',  label: 'Ridgeland',  color: '#c06060' },
  { value: 'Remote',     label: 'Remote',     color: '#8090a0' },
];

// ─── Source grouping ─────────────────────────────────────────────────────────

/** Entry types stored in SQL (not sourced from PE). */
export const SUPPLEMENTARY_TYPES: EntryType[] = [
  'Appointment',
  'Work',
  'Flexing Off',
  'Friday Work',
  'Deadline',
  'Sabbatical',
  'Holiday',
  'Other',
];

/** Entry types sourced from Practice Engine. */
export const PE_TYPES: EntryType[] = [
  'PTO',
  'Tentative PTO',
  'Holiday',
  'Half Day',
];
